import {API_BASE_URL} from './Settings';

export async function getApplications() {
    const savedFirm = localStorage.getItem('selectedFirm');
    const firm = savedFirm ? JSON.parse(savedFirm) : null;

    const response = await fetch(`${API_BASE_URL}/applications/Firm/${firm?.idt}`);
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}
